import salesOrder from './index.js';

const SET_IN_STOCK_ITEMS = (state, inStockItems) => {
  state.items = inStockItems;
  state.itemsOudated=false;
};

const INVALIDATE_STOCK_ITEMS = (state)=>{
  state.allItemOutdated=true;
  state.itemsOudated=true;
}

const SET_IN_ALL_ITEMS = (state, inStockItems) => {
  state.allItems = inStockItems;
  state.allItemOutdated=false;
};

const INVALIDATE_ALL_ITEMS  = (state)=>{
  state.allItemOutdated=true;
  state.itemsOudated=true;
}

export default {
  SET_IN_STOCK_ITEMS,
  INVALIDATE_STOCK_ITEMS,
  SET_IN_ALL_ITEMS,
  INVALIDATE_ALL_ITEMS
};
